import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataGrid, { Column, HeaderFilter, Pager } from "devextreme-react/data-grid";
import { fetchAuditTrail } from "../Redux/feasibility";

export default function AuditTrail({ sfqId }) {
  const dispatch = useDispatch();
  const auditTrail = useSelector((s) => s.feasibility.auditTrail);

  useEffect(() => {
    if (sfqId) dispatch(fetchAuditTrail(sfqId));
  }, [sfqId, dispatch]);

  return (
    <DataGrid
      dataSource={auditTrail}
      showBorders
      rowAlternationEnabled
      columnAutoWidth
      wordWrapEnabled
      style={{ fontSize: 13 }}
    >
      <HeaderFilter visible />
      <Pager
        allowedPageSizes={[5, 10, 20, 30, "all"]}
        displayMode="full"
        showPageSizeSelector={true}
        showInfo={true}
        showNavigationButtons={true}
        visible={true}
      />

      <Column dataField="performedAt" caption="Date/Time" dataType="datetime" format="yyyy-MM-dd HH:mm:ss" width={160} />
      {/* Study-level events carry no invitation, so this is blank for them. */}
      <Column dataField="invitationSiteName" caption="Site" width={160} />
      <Column dataField="performedByName" caption="Performed By" width={130} />
      <Column dataField="action"      caption="Action"      width={180} />
      <Column dataField="field"       caption="Field"       width={120} />
      <Column dataField="oldValue"    caption="Old Value" allowHeaderFiltering={false} />
      <Column dataField="newValue"    caption="New Value" allowHeaderFiltering={false} />
      <Column dataField="comment"     caption="Comment"   allowHeaderFiltering={false} />
      <Column dataField="ipAddress"   caption="IP"          width={120} allowHeaderFiltering={false} />
    </DataGrid>
  );
}
